import { rootRoutes } from '@pendwa/common/core/rootRoutes/index.js';
export function reloadPage() {
    window.location.reload();
}
export function redirectToLogin() {
    window.location.href = rootRoutes.app.account.login.get();
}
export function redirectToHome() {
    window.location.href = '/';
}
export function redirectToPath(path, new_tab, replace = false) {
    if (new_tab) {
        window.open(path);
    }
    else {
        if (replace) {
            window.location.replace(path);
        }
        else {
            window.location.href = path;
        }
    }
}
export function openNewTab(path) {
    return window.open(path);
}
//# sourceMappingURL=index.js.map